import {
    assistantAsking,
    assistantAskingForAction,
    assistantAskingForContext, assistantAskingForExample,
    assistantAskingForGenre, assistantAskingForInstructions, assistantAskingForRequirements, assistantAskingForSchema,
    assistantAskingForSynopsis,
    systemInstruction,
    userSaying
} from "../../../../../../../ai/Utils"
import {DraftAct} from "../../../../../../../feature/Draft";



export const generateActsPrompt = (vars: {
    genres: string[],
    synopsis: string,
    context?: string[]
}) => systemInstruction("Ты профессиональный писатель")
    .concat(userSaying("Я работаю над созданием литературного произведения"))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Придумай содержимое актов",
        "Проработай содержимое актов",
        "Дополни содержимое актов",
        "Придумай названия актам",
        "Разбей содержимое каждого акта на абзацы"
    ]))
    .concat(assistantAskingForRequirements([
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": [{"id":number, "title":string, "description":string}],}'))
    .concat(assistantAskingForExample({
        data: [
            {
                id: 1,
                title: "Находка",
                description: "- В ночь на 31 декабря главный герой отправляется в поход и находит магический артефакт.\n\n- Он приносит артефакт домой и замечает изменения вокруг себя"
            }
        ]
    }))
    .concat(assistantAskingForAction(`Сгенерируй 3 акта сюжета (1 акт - завязка, 2 акт - кульминация, 3 акт - развязка).`))


export const generateActPrompt = (vars: {
    genres: string[],
    synopsis: string,
    act: number,
    acts: DraftAct[],
    context?: string[]
}) => systemInstruction("Ты профессиональный писатель")
    .concat(userSaying("Я работаю над созданием литературного произведения"))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши акты произведения", JSON.stringify(vars.acts.map((item) => ({
        act: item.id,
        content: item.description
    })))))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Придумай содержимое акта",
        "Проработай содержимое акта",
        "Разбей содержимое акта на абзацы"
    ]))
    .concat(assistantAskingForRequirements([
        "Объем текста должен оставаться таким же как в исходном акте",
        "События не должны пересекаться с другими актами",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": {"id":number, "title":string, "description":string}'))
    .concat(assistantAskingForExample({
        data: {
            id: 1,
            title: "Находка",
            description: "- В ночь на 31 декабря главный герой отправляется в поход и находит магический артефакт.\n\n- Он приносит артефакт домой и замечает изменения вокруг себя"
        }
    }))
    .concat(assistantAskingForAction(`Перегенерируй существующий или сгенерируй новый ${vars.act}-й акт истории.`))


export const improveActPrompt = (vars: {
    genres: string[],
    synopsis: string,
    act: number,
    acts: DraftAct[],
    context?: string[]
}) => systemInstruction("Ты профессиональный писатель")
    .concat(userSaying("Я работаю над созданием литературного произведения"))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши акты произведения", JSON.stringify(vars.acts.map((item) => ({
        act: item.id,
        content: item.description
    })))))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Определи можно и нужно ли улучшить содержимое акта",
        "Дополни текущее содержимое акта действиями и событиями, чтобы разнообразить сюжет",
        "Разбей содержимое акта на абзацы"
    ]))
    .concat(assistantAskingForRequirements([
        "События не должны пересекаться с другими актами",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": {"id":number, "title":string, "description":string}'))
    .concat(assistantAskingForExample({
        data: {
            id: 1,
            title: "Находка",
            description: "- В ночь на 31 декабря главный герой отправляется в поход и находит магический артефакт.\n\n- Он приносит артефакт домой и замечает изменения вокруг себя"
        }
    }))
    .concat(assistantAskingForAction(`Дополни ${vars.act}-й акт истории если необходимо.`))